<template>
  <div class="index" v-if="obj.url && obj.data">
    <div class="content"
      :style="{ backgroundImage: `url(${obj.url})`, width: (obj.width + 'px'), height: (obj.height + 'px') }">
      <div v-for="(item, index) in obj.data" :key="index" class="text" :style="styleFn(item)"> {{ textFn(item) }}
      </div>
    </div>
  </div>
</template>

<script>
import { resultConfig } from "@/api/index";
export default {
  name: "index",
  components: {},
  data() {
    return {
      obj: {},
      resultInfo: {}
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.resultConfig();
    },
    textFn(item) {
      // console.log(this.obj, "this.obj");
      if (this.resultInfo && this.resultInfo[item.field] || this.resultInfo[item.field] === 0) {
        if (item.field == "gender") {
          return this.resultInfo[item.field] == 1 ? "男" : "女";
        }
        return this.resultInfo[item.field];
      }
      return "-"
      // return item.text;
    },
    styleFn(item) {
      // console.log(item, "item");
      const obj = {
        left: item.x + "px",
        top: item.y + "px",
        fontSize: item.fontSize + "px",
        lineHeight: item.fontSize + "px",
        textAlign: item.textAlign,
      }
      if (item.width) {
        obj.width = item.width + "px";
      }
      return obj;
    },
    resultConfig() {
      // console.log(this.$route.query, "this.$route.query");
      resultConfig({
        matchId: this.$route.query.matchId || "",
        matchProjectInfoId: this.$route.query.matchProjectInfoId || "",
        resultId: this.$route.query.resultId || "",
      }).then(res => {
        if (res.resutlCode == "00000") {
          if (res.data && res.data.certificateTemplateJson) {
            const obj = JSON.parse(res.data.certificateTemplateJson);
            this.obj = obj;
            console.log(this.obj, "this.obj");
            this.resultInfo = res.data.resultInfo || {};
          }
        }
      })
    }
  }
};
</script>

<style scoped lang="less">
/* 内容 */
.content {
  position: relative;
  background-size: 100%;
  background-repeat: no-repeat;

  .text {
    position: absolute;
    font-weight: bold;
    font-family: "宋体";
    // font-family: "黑体";
    // font-family: "SimHei", "Microsoft YaHei", "黑体", sans-serif;
  }
}
</style>
